import React, { useMemo } from 'react';

import { Link, Typography } from '@mui/material';

export const DocumentationInfo = ({ type }: { type: 'csv' | 'json' | 'python' }) => {
  const content = useMemo(() => {
    switch (type) {
      case 'csv':
        return {
          link: 'https://docs.g-x.co/#index-keys',
          name: 'GX CSV file format'
        };
      case 'json':
        return {
          link: 'https://docs.g-x.co/#API',
          name: 'GX API'
        };
      case 'python':
        return {
          link: 'https://docs.g-x.co/#python-sdk',
          name: 'GX SDK'
        };
      default:
        return {
          link: 'https://docs.g-x.co',
          name: 'GX'
        };
    }
  }, [type]);
  return (
    <Typography sx={theme => ({ fontSize: theme.typography.pxToRem(12), my: 0.5 })}>
      For more information on the {content.name}, please visit our{' '}
      <Link
        href={content.link}
        rel='noopener noreferrer'
        target='_blank'
        underline='hover'
      >
        documentation site
      </Link>
      .
    </Typography>
  );
};
